import React from "react";

const HeightSelector = ({ value, onChange, disabled = false }) => {
  const [feet, setFeet] = React.useState('');
  const [inches, setInches] = React.useState('');

  React.useEffect(() => {
    // Parse height string like "5ft 4in" or "5'4""
    if (value) {
      setFeet(value.heightFeet.toString());
      setInches(value.heightInches.toString());  
    }
  }, [value]);

  const handleChange = (field, e) => {
    try {
      let value;
      
      if (!e) {
        // Handle programmatic changes
        value = e;
        console.log(`HeightSelector ${field} changed programmatically to:`, value);
      } else if (e.target) {
        // Handle normal change events
        value = e.target.value;
        console.log(`HeightSelector ${field} changed to:`, value);
      } else {
        console.warn('HeightSelector: Invalid event', e);
        return;
      }
      
      const numValue = value === '' ? '' : parseInt(value) || 0;
      
      if (field === 'feet') {
        setFeet(numValue.toString());
        setInches(inches);
      } else if (field === 'inches') {
        setInches(numValue.toString());
        setFeet(feet);
      } else {
        console.warn('HeightSelector: Unknown field', field);
        return;
      }
      
      // Combine and call parent onChange with both string and separate fields
      const feetValue = field === 'feet' ? numValue : parseInt(feet) || 0;
      const inchesValue = field === 'inches' ? numValue : parseInt(inches) || 0;
      const combinedHeight = (feetValue || inchesValue) ? `${feetValue || 0}ft ${inchesValue || 0}in` : '';
      
      // Create a custom event object with all height data
      const heightData = {
        target: {
          name: 'height',
          value: combinedHeight,
          // Add separate fields for backend
          heightFeet: feetValue,
          heightInches: inchesValue
        }
      };
      
      console.log('HeightSelector calling parent onChange with:', heightData);
      onChange(heightData);
    } catch (error) {
      console.error('HeightSelector error:', error);
    }
  };

  // Handle touch events for mobile
  const handleTouchEnd = (field, e) => {
    try {
      if (!e || !e.target) {
        console.warn('HeightSelector: No touch event available');
        return;
      }
      
      const value = e.target.value;
      console.log(`HeightSelector ${field} touch ended with:`, value);
      
      const numValue = value === '' ? '' : parseInt(value) || 0;
      
      if (field === 'feet') {
        setFeet(numValue.toString());
        setInches(inches);
      } else if (field === 'inches') {
        setInches(numValue.toString());
        setFeet(feet);
      }
      
      // Combine and call parent onChange for touch events
      const feetValue = field === 'feet' ? numValue : parseInt(feet) || 0;
      const inchesValue = field === 'inches' ? numValue : parseInt(inches) || 0;
      const combinedHeight = (feetValue || inchesValue) ? `${feetValue || 0}ft ${inchesValue || 0}in` : '';
      
      // Create a custom event object with all height data
      const heightData = {
        target: {
          name: 'height',
          value: combinedHeight,
          // Add separate fields for backend
          heightFeet: feetValue,
          heightInches: inchesValue
        }
      };
      
      console.log('HeightSelector touch calling parent onChange with:', heightData);
      onChange(heightData);
    } catch (error) {
      console.error('HeightSelector touch error:', error);
    }
  };

  return (
    <div className="flex gap-2">
      <div className="flex-1">
        <label className="block text-sm font-medium text-[var(--color-text-muted)]">
          Height
        </label>
        <select
          value={feet}
          onChange={(e) => handleChange('feet', e)}
          onTouchEnd={(e) => handleTouchEnd('feet', e)}
          disabled={disabled}
          className="w-full rounded-lg border border-[var(--color-border)] px-3 py-2 text-sm"
        >
          <option value="">Feet</option>
          {[...Array(9)].map((_, i) => (
            <option key={i} value={i}>{i}</option>
          ))}
        </select>
      </div>

      
      <div className="flex-1">
        <label className="block text-sm font-medium text-[var(--color-text-muted)]">
          &nbsp;
        </label>
        <select
          value={inches}
          onChange={(e) => handleChange('inches', e)}
          onTouchEnd={(e) => handleTouchEnd('inches', e)}
          disabled={disabled}
          className="w-full rounded-lg border border-[var(--color-border)] px-3 py-2 text-sm"
        >
          <option value="">Inches</option>
          {[...Array(12)].map((_, i) => (
            <option key={i} value={i}>{i}</option>
          ))}
        </select>
        </div>
    </div>
  );
};

export default HeightSelector;
